import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";

import cloudinary from "../../utils/cloudinary";
import { Gravatar } from "./Gravatar";

const getPhotoByWidth = (size: number, publicId: string) =>
  `${cloudinary.BASE_URL}c_fill,q_auto:good,f_auto,w_${size},h_${size}/v1/${publicId}`;

const defaultStyle: React.CSSProperties = {
  borderRadius: "2rem",
  marginBottom: "0rem",
};

type ProfilePictureProps = {
  user?: {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    profilePicture?: { publicId?: string | null } | null;
    profilePictureLocal?: {
      childImageSharp?: { gatsbyImageData: IGatsbyImageData } | null;
    } | null;
  } | null;
  size?: "small";
  style?: React.CSSProperties;
};

const ProfilePicture: React.FC<ProfilePictureProps> = ({ user, size, style }) =>
  user &&
  (getImage(user.profilePictureLocal as any) ? (
    <GatsbyImage
      alt={`${user.firstName} ${user.lastName}`}
      image={getImage(user.profilePictureLocal as any)!}
      imgStyle={{
        marginLeft: 0,
        marginRight: 0,
        marginBottom: 0,
      }}
      style={Object.assign(
        {
          width: size && size === "small" ? "50px" : "200px",
          height: size && size === "small" ? "50px" : "200px",
          minWidth: size && size === "small" ? "50px" : "200px",
        },
        defaultStyle,
        style,
      )}
    />
  ) : user.profilePicture ? (
    <img
      alt={`${user.firstName} ${user.lastName}`}
      title={`${user.firstName} ${user.lastName}`}
      width={size && size === "small" ? "50" : "200"}
      height={size && size === "small" ? "50" : "200"}
      src={getPhotoByWidth(
        size && size === "small" ? 50 : 200,
        user.profilePicture.publicId!,
      )}
      srcSet={`${getPhotoByWidth(
        50,
        user.profilePicture.publicId!,
      )} 50w, ${getPhotoByWidth(
        100,
        user.profilePicture.publicId!,
      )} 100w, ${getPhotoByWidth(
        200,
        user.profilePicture.publicId!,
      )} 200w ,${getPhotoByWidth(400, user.profilePicture.publicId!)} 400w`}
      sizes={size && size === "small" ? "50px" : "200px"}
      style={Object.assign({}, defaultStyle, style)}
    />
  ) : (
    <Gravatar
      email={(user && user.email) ?? ""}
      size={size && size === "small" ? 50 : 200}
      style={Object.assign({}, defaultStyle, style)}
      alt={`${user.firstName} ${user.lastName}`}
      title={`${user.firstName} ${user.lastName}`}
    />
  ));

export default ProfilePicture;
